import { CONTENT_WIDTH } from '@app/core/cms-flex/types';

import { ColumnWidth } from '../types';

export const COLUMN_WIDTH = new Map<CONTENT_WIDTH, ColumnWidth>()
  .set(CONTENT_WIDTH.WIDTH_6_12, 'column-width__6')
  .set(CONTENT_WIDTH.WIDTH_7_12, 'column-width__7')
  .set(CONTENT_WIDTH.WIDTH_8_12, 'column-width__8');
